<section class="footer__container">
  <div>
    <button
      [disabled]="disableButton"
      (click)="buttonClicked()"
      class="footer__button-save"
      mat-raised-button
      aria-label="close modal"
    >
      <div [ngClass]="{ footer__downloading: isloading }">
        <mat-spinner *ngIf="isloading" diameter="30"></mat-spinner>
        <span class="btn-text ml-8"> {{ name }} </span>
      </div>
    </button>
  </div>
</section>
